<template>
  <el-container style="height: 100%;">
    <!-- 顶部导航栏 -->
    <el-header style="background-color: white; color: black; padding: 0;">
      <div class="logo">交通培训平台</div>
      <el-menu mode="horizontal" class="nav-menu" :default-active="currentPage">
        <el-menu-item index="1" @click="showPage('Home')">首页</el-menu-item>
        <el-menu-item index="2" @click="showPage('MyTrainingPlan')">我的培训计划</el-menu-item>
        <el-menu-item index="3" @click="showPage('StudyStatus')">学习情况</el-menu-item>
        <el-menu-item index="4" @click="showPage('ExamRecord')">考试记录</el-menu-item>
        <el-menu-item index="5" @click="showPage('Profile')">个人中心</el-menu-item>
      </el-menu>
    </el-header>

    <!-- 主体内容区域 -->
    <el-container>
      <el-main>
        <!-- 根据状态动态显示不同的组件 -->
        <TrainingPlan v-if="currentPage === 'TrainingPlan'" :userid="userid" :organizationID="organizationID" />
        <MyTrainingPlan v-if="currentPage === 'MyTrainingPlan'" :userid="userid" :organizationID="organizationID" />
        <StudyStatus v-if="currentPage === 'StudyStatus'" :userid="userid" :organizationID="organizationID" />
        <ExamRecord v-if="currentPage === 'ExamRecord'" :userid="userid" :organizationID="organizationID" />
        <Profile v-if="currentPage === 'Profile'" :userid="userid" :organizationID="organizationID" />
        <Home v-if="currentPage === 'Home'" :userid="userid" :organizationID="organizationID" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// 引入页面组件
import TrainingPlan from '../views/TrainingPlan.vue';
import MyTrainingPlan from '../views/TrainingPlan.vue'; // 确保这里是正确的组件文件
import StudyStatus from '../views/StudyStatus.vue';
import ExamRecord from '../views/ExamRecord.vue';
import Profile from '../views/Profile.vue';
import Home from '../views/Home.vue';

export default {
  components: {
    TrainingPlan,
    MyTrainingPlan,
    StudyStatus,
    ExamRecord,
    Profile,
    Home
  },
  // props: {
    // userid1: {
    //   type: Number,  // 假设用户ID是字符串
    //   required: true
    // },
    // organizationID1: {
    //   type: Number,  // 假设机构ID是字符串
    //   required: true
    // }
  // },
  data() {
    return {
      currentPage: 'Home', // 默认显示首页
      userid: this.$route.query.userid, // 获取路由中的用户id
      organizationID: this.$route.query.organizationID,// 获取路由中的机构id
    };
  },
  methods: {
    // 显示对应页面
    showPage(page) {
      this.currentPage = page;
    },
    logout() {
      this.$router.push("/login"); // 退出登录时跳转到登录页
    }
  },

  created() {
    // 这里可以做一些验证，确保用户ID和机构ID的存在
    console.log("用户ID:", this.userid);
    console.log("机构ID:", this.organizationID);


  }
};
</script>

<style scoped>
/* 顶部导航栏的样式 */
.el-header {
  background-color: white; /* 设置背景为白色 */
  color: black; /* 设置文字颜色为黑色 */
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* logo 样式 */
.logo {
  font-size: 20px;
  font-weight: bold;
  color: black; /* 设置 logo 字体颜色为黑色 */
  padding: 10px;
  display: inline-block;
}

/* 菜单项样式 */
.nav-menu {
  display: inline-block;
  margin-left: 20px;
  flex-grow: 1;
}

/* 主体内容区域 */
.el-container {
  flex: 1;
  display: flex;
}

/* 右侧显示区域 */
.el-main {
  background-color: #fff;
  padding: 20px;
  flex: 1;
}
</style>
